import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { LeadsDataConstant } from "./LeadsContant";


const initialState = {
    leadsDataList: [],
    LeadData: {
        isLoading: false,
    },
};

export const LeadsDataReducers = persistReducer(
    {
        storage,
        key: "leadsData",
        whitelist: 'leadsDataList',
    },
    (state = initialState, { type, payload }) => {
        switch (type) {

            case LeadsDataConstant.LEADS_DATA_REQUEST: {
                return {
                    ...state,
                    leadsDataList: [],
                    LeadData: {
                        isLoading: true,
                    },
                };
            }
            case LeadsDataConstant.LEADS_DATA_RESPONSE: {

                return {
                    ...state,
                    leadsDataList: payload,
                    LeadData: {
                        isLoading: false,
                    },
                };
            }
            default:
                return state;
        }
    }
);
